import { useDispatch } from 'react-redux';
import { MenuItem, Typography } from '@mui/material';
import { useAuth0 } from '@auth0/auth0-react';

import feVersion from '../../../feVersion.json';
import { FMenu } from '../../base';
import { authActions } from '../../../store';
import { FORTA_BLACK, FORTA_BLUE, FORTA_GRAY3 } from '../../../utils/colors';

interface ProfileMenuProps {
  user: any;
  open: boolean;
  anchorEl: null | HTMLElement;
  onClose: () => void;
}

function ProfileMenu(props: ProfileMenuProps) {
  const dispatch = useDispatch();
  const { logout } = useAuth0();
  const { user, open, anchorEl, onClose } = props;

  const handleLogout = async () => {
    logout({ logoutParams: { returnTo: window.location.origin } });
    dispatch(authActions.logout());
    onClose();
  };

  return (
    <FMenu id="basic-menu" anchorEl={anchorEl} open={open} onClose={onClose}>
      <MenuItem sx={{ minWidth: 150 }} onClick={onClose} disabled={true}>
        <Typography fontWeight="bold" style={{ color: FORTA_BLACK }}>
          {user?.name}
        </Typography>
      </MenuItem>
      <MenuItem onClick={handleLogout}>
        <Typography fontWeight="bold">Log out</Typography>
      </MenuItem>
      {feVersion?.version && (
        <MenuItem
          disableRipple
          sx={{
            position: 'absolute',
            top: 35,
            right: 2,
            '&:hover': { background: FORTA_BLUE.light3 },
          }}
        >
          <Typography fontSize={10} sx={{ color: FORTA_GRAY3 }}>
            {feVersion.version}
          </Typography>
        </MenuItem>
      )}
    </FMenu>
  );
}

export default ProfileMenu;
